// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"26":"c75042de612dadc2","70":"d199ad50dcde787a"}[chunkId] + ".js";
};